import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var golfClub = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "14",
    viewBox: "0 0 12 14"
  }, props), React.createElement("path", {
    d: "M8.038.534L1.372 4.238A2.667 2.667 0 0 0 0 6.569V14h2V9h7.333A2.667 2.667 0 0 0 12 6.333V2.865C12 .832 9.816-.453 8.038.535z"
  }));
});

export default golfClub;
//# sourceMappingURL=golf-club.svg.js.map
